module.exports = __webpack_public_path__ + "img/sld_mppt_1_t1_green.a31e1946.svg";